module.exports = __webpack_public_path__ + "img/ADA.1de4288c.png";